import { AutoflowToolTranscriptComponent } from './types';
import { ColorMode } from 'src/components/app/types';
import { GenericToolMessage } from 'src/pages/workflow-builder-preview/voice-preview/inbound-preview/info-console/PreviewExecutionMessage';

export const AutoflowTool = ({
  theme,
  transcriptComponent,
}: {
  theme?: ColorMode;
  transcriptComponent: AutoflowToolTranscriptComponent;
}) => {
  return (
    <GenericToolMessage
      payload={{ ...transcriptComponent, type: 'generic_tool' }}
      theme={theme}
    />
  );
};
